var _style, _path, _path2, _path3, _path4, _g, _g2, _g3, _path5, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g11, _g12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Error({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6331805-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ebebeb } \n\t\t.s1 { fill: #455a64 } \n\t\t.s2 { fill: #ffc727 } \n\t\t.s3 { opacity: .2;fill: #000000 } \n\t\t.s4 { opacity: .1;fill: #000000 } \n\t\t.s5 { fill: #c7c7c7 } \n\t\t.s6 { fill: #37474f } \n\t\t.s7 { fill: #263238 } \n\t\t.s8 { fill: #f7a9a0 } \n\t\t.s9 { fill: #a6a6a6 } \n\t\t.s10 { fill: #ff9abb } \n\t\t.s11 { fill: #000000 } \n\t\t.s12 { opacity: .1;fill: #455a64 } \n\t\t.s13 { fill: #ffffff } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m49.8 479.7c0.5-4.4 1.6-8.5 2.8-12.5 1.2-4 2.6-7.8 4-11.6 2.8-7.7 5.7-15.2 8.3-22.8q3.9-11.3 6.9-22.9c2-7.7 3.6-15.5 4.9-23.2 2.4-15.6 3.2-31.3 2.5-46.7-0.2-3.9-0.5-7.8-0.7-11.6-0.4-3.9-0.8-7.4-1.2-11.9-0.7-8.7-1-17.5-0.8-26.4 0.5-17.7 3.2-36 9-53.8 5.7-17.8 14.5-35.2 26.3-50.5 11.8-15.3 26.1-28.6 41.8-39.5 15.8-10.8 32.9-19.2 50.5-25.4q13.2-4.6 27-7.6c4.5-1 9.1-1.8 13.8-2.5l11.4-1.6c14.2-2.3 27.9-5.3 41.2-9.9 13.4-4.3 26.5-10.2 40.7-17 14.1-6.8 29.4-14.7 46.1-21.2 8.3-3.2 16.9-6.2 25.6-8.6 4.4-1.2 8.8-2.2 13.2-3.2l6.6-1.3c2.5-0.5 5-0.9 7.6-1.2 10.1-1.3 20.7-1.4 31.2 0.3 10.5 1.6 21 5 30.6 10.3 9.7 5.3 18.4 12.6 25.2 21.3 6.9 8.7 11.8 18.8 14.3 29.2 2.6 10.3 2.9 20.8 1.7 30.7-1.3 9.9-4.1 19.2-7.8 27.7-7.7 17-18.5 31.2-30.4 43.6-6 6.3-12.5 12-19.2 17.4-6.8 5.2-13.9 10.1-21.1 14.4-29.1 17.6-60.9 27.6-90.1 40.4-14.6 6.2-28.6 13.3-39.6 22.1-5.5 4.4-10.1 9.2-13.5 14.3q-1.3 1.9-2.4 3.9c-0.7 1.2-1.4 2.5-2.1 4-1.4 2.8-2.7 6-3.9 9.3-2.5 6.5-4.7 13.7-6.7 21.1-2.1 7.3-4 14.8-6 22.4l-5.8 23.1c-2 7.7-4 15.5-6.1 23.3-8.7 31.3-18.7 62.9-34.1 93.9-7.8 15.4-16.9 30.7-29 44.9-3.1 3.6-6.2 7-9.7 10.4-3.5 3.4-7.1 6.6-11.2 9.6-3.9 3-8.2 5.8-12.8 8.3-2.2 1.2-4.7 2.3-7.1 3.3l-3.6 1.5c-1.2 0.4-2.3 0.7-3.4 1.1-8.8 2.8-17.9 4.9-27.3 5.7-9.3 0.9-18.9 0.6-28.2-1.2-9.3-1.8-18.2-5.3-26.2-10-4-2.3-7.7-5.1-11.1-8.1-3.5-2.9-6.6-6.1-9.5-9.6-11.3-13.8-17.6-30.1-20.9-46.4-3.2-16.4-3.4-33-1.7-49.3zm6.2 0.6c-1.8 15.7-1 31.8 3.4 46.8 4.3 14.9 12.2 28.8 23.5 38.2q4.2 3.5 8.8 6.2c3.1 1.7 6.3 3.1 9.6 4.2 6.6 2.3 13.4 3.1 20.2 2.7 13.6-0.7 26.6-5.8 38.5-13.2 0.7-0.5 1.5-1 2.2-1.4l1.7-1.3c1.1-0.9 2.2-1.8 3.3-2.8q3.2-2.9 6.2-6.6c4-4.7 7.7-10.2 11-16.2 6.8-11.9 12.6-25.4 18-39.4 10.8-28 20.3-57.9 31-88.2q4-11.4 8.3-22.8c2.9-7.6 5.9-15.3 9.1-22.9 6.4-15.4 13.4-30.8 22.8-46.4 2.4-3.9 5-7.8 8-11.7 1.5-2 3.1-4 4.8-5.9q2.6-2.9 5.4-5.4c7.3-6.9 15.5-12.2 23.7-16.4 16.4-8.3 32.7-12.8 48.4-17.5 15.7-4.5 31.1-8.8 45.9-14.3 14.7-5.5 28.9-12.2 41.7-20.7 12.8-8.3 24.1-18.6 33.2-30.5 9.1-11.9 16.3-25.1 19.5-38.5 1.6-6.7 2.3-13.3 1.9-19.5-0.4-6.2-1.9-12-4.3-17-4.8-10-13.1-16.7-22.9-19.9-4.9-1.6-10.2-2.4-15.7-2.4-5.5-0.1-11.2 0.6-17 2q-2.1 0.6-4.3 1.2l-5.1 1.6c-3.4 1-6.8 2.2-10.1 3.4-6.6 2.5-13.1 5.2-19.6 8.3-13 6.2-25.9 14-40.2 22.4-14.3 8.3-30.2 16.7-47 23.5-17 6.7-34.6 11.8-52.2 15-2.2 0.5-4.4 0.8-6.6 1.1l-5.9 1q-4.9 0.8-9.9 1.9c-6.6 1.5-13.2 3.3-19.6 5.4-25.8 8.5-49 21.9-66.7 40.9-8.9 9.4-16.8 20.1-23.4 32-3.4 6-6.5 12.2-9.1 18.8-2.8 6.6-5.2 13.4-7.4 20.5-2.1 7-3.9 14.3-5.4 21.7-0.7 3.5-1.5 8.1-2.3 12.2-0.8 4.2-1.7 8.4-2.7 12.6-4 16.6-9.1 32.7-15.2 48.2-6 15.6-13 30.5-20.1 45.1-3.5 7.4-7 14.6-10.2 21.9-3.2 7.3-6.2 14.8-7.2 22.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m672.1 880.3c-18.3 2.6-36 8.4-53 15.7-17.1 7.3-33.5 16-50 25-8.4 4.4-16.7 8.9-25.3 13.2-8.5 4.3-17.4 8.5-26.8 12-9.5 3.4-19.6 6.3-30.7 7.5-11.1 1.1-23.6 0.4-35.7-4-3.1-1.1-6-2.6-8.9-3.9-2.9-1.6-5.6-3.3-8.4-5-2.6-1.9-5.2-3.8-7.7-5.8q-3.4-3.2-6.9-6.5c-8.3-8.5-15.4-18.5-21-29.2-5.7-10.6-9.6-21.9-12.3-33-2.7-11.1-4.2-22.1-4.9-32.8-1.5-21.4-0.3-41.6 1.1-60.8l2.3-28.2c0.4-4.6 0.6-9.2 0.9-13.7l0.4-6.7 0.3-6.7c0.2-8.8 0.3-17.4-0.4-25.8-0.5-8.4-1.7-16.7-3.5-24.2-1.9-7.9-5-16.1-8.6-24.3-3.6-8.2-7.8-16.6-12.3-24.9-9-16.7-19.2-33.4-29.1-50.6l-7.4-13c-2.4-4.5-4.8-8.9-7.1-13.5-4.6-9.1-8.7-18.6-11.9-28.6-3.3-10-5.5-20.7-5.4-31.8 0-11 2.7-22.1 7.4-31.7 2.4-4.9 5.4-9.3 8.5-13.5l4.9-6c1.7-1.9 3.5-3.6 5.2-5.4 7-7 14.7-13.5 23-19.2 8.3-5.5 17.2-10.4 26.5-14.3 2.3-0.9 4.6-1.9 7-2.7l7.2-2.5c4.9-1.4 9.7-2.7 14.7-3.7 19.8-4.3 40.4-5.2 60.6-3.4 10.1 0.8 20.2 2.2 30.1 4.2 10 1.9 19.8 4.5 29.5 7.3 4.9 1.5 9.8 2.9 14.5 4.6l7.2 2.5 7.1 2.7q14.1 5.6 27.8 12.1c4.6 2.2 9.1 4.4 13.6 6.7 4.5 2.3 8.9 4.7 13.3 7.2 4.4 2.5 8.8 4.9 13.1 7.5 4.3 2.7 8.7 5.2 12.9 8l24.2 15.7c4 2.6 8 5 11.9 7.5l6 3.7 6 3.5c32 19.3 64.9 35.9 98.8 51.1 17.1 7.5 34.3 14.8 52.5 23 9.1 4.1 18.4 8.7 28.1 14.1 9.5 5.5 19.5 11.8 28.9 19.9 9.4 8 18.2 17.5 25.3 27.7 7.3 10.2 12.7 20.9 17.3 31.4 2.4 5.3 4.2 10.5 6.1 15.7 0.9 2.6 1.7 5.2 2.5 7.8 0.9 2.6 1.7 5.1 2.4 7.9l2.2 8.2 1 4.1 0.8 4.3c1 5.6 2.2 11.2 2.5 17.1 0.3 2.9 0.6 5.9 0.8 8.8v8.9 4.5c0 1.4-0.2 3-0.4 4.5l-0.9 8.9c-0.4 3-1.1 6-1.7 8.9l-1 4.5c-0.3 1.4-0.8 2.9-1.3 4.3-0.9 2.9-1.7 5.8-2.7 8.6-1.2 2.8-2.4 5.6-3.6 8.3-5.2 10.7-11.6 20.7-19.4 28.9l-2.8 3.2c-0.9 1-2 1.9-3 2.9-2 1.9-4 3.8-6 5.6-4.3 3.3-8.4 6.9-12.9 9.7-8.7 6.1-17.9 10.7-27.1 15.1-9.2 4-18.5 7.7-27.9 10.6-18.7 5.9-37.5 10.2-56.3 13.7-4.7 0.8-9.4 1.8-14.1 2.5-4.7 0.7-9.3 1.6-14 2.3-4.7 0.8-9.4 1.4-14 2.1l-14.1 2.1zm-1-6.2c18.5-2.7 36.9-6 55.1-10.4l6.8-1.6 6.7-1.8c4.6-1.1 9-2.5 13.4-3.8 9-2.7 17.7-5.7 26.4-8.9 17.3-6.5 33.9-14.3 49.3-23.5 7.8-4.5 15-9.7 21.9-14.9 6.8-5.4 13.3-11 18.7-17.1 3-2.9 5.3-6.2 7.8-9.2l3.4-4.9c0.5-0.8 1.1-1.5 1.6-2.3l1.4-2.5c3.9-6.5 6.6-13.4 8.4-20.2 0.4-1.7 0.8-3.4 1.3-5.1l0.8-5.3c0.1-0.8 0.3-1.7 0.4-2.6l0.1-2.6c0-1.8 0.2-3.6 0.2-5.4l-0.2-5.4c0-0.9 0.1-1.8-0.1-2.7l-0.3-2.8-0.6-5.5-1.1-5.6c-1.4-7.5-3.7-15.2-6.4-22.9-0.5-1.9-1.3-4-2.1-6-0.8-1.9-1.5-4-2.4-5.9-1.7-3.8-3.2-7.7-5.1-11.2-3.5-7.2-7.3-13.7-11.6-19.3-4.3-5.5-8.9-10.3-14.3-14.7-10.8-8.7-25.6-16.4-42.3-24.2-8.3-4-16.9-7.9-25.7-12-8.8-4-17.7-8.4-26.5-12.7-35.5-17.5-70.3-38-103.1-60.4l-6.1-4.2-6.1-4.3c-4.1-2.9-8.2-5.7-12.2-8.7l-23.3-17.2c-7.5-5.5-15-10.8-22.6-16l-11.5-7.6c-3.9-2.4-7.7-4.9-11.6-7.3-7.8-4.7-15.7-9.5-23.7-13.7l-6-3.3-6-3.1c-4.1-2.1-8.2-3.9-12.2-5.9-16.5-7.4-33.3-13.7-50.6-17.7-8.6-2.1-17.3-3.4-26-4.3-8.8-0.9-17.5-0.8-26.1 0-17.3 1.3-34 6.6-49 15.2-7.5 4.4-14.5 9.7-20.8 15.7-1.6 1.5-3.3 3-4.7 4.5l-4.2 4.7c-2.5 3.4-4.9 6.7-6.7 10.4-3.7 7.2-5.6 15.2-5.4 23.4 0.1 8.3 2.1 16.8 5.3 25.1 3.2 8.3 7.6 16.4 12.4 24.3 4.9 7.9 10.3 15.6 16.1 23.3 11.5 15.2 24 30.1 36.3 46 6.2 7.9 12.2 16.2 17.9 25.1 5.7 8.8 11.1 18.2 15.6 28.7 9.1 21.5 12.6 43.3 14.1 64.2 2.8 41.8-2.6 80.2-1.8 114.6 0.4 17.2 2.2 33.1 7.2 47.1 2.5 7.1 5.9 13.7 10.1 20 4 5.8 8.3 10.5 13.7 14 5.4 3.4 12.1 5.8 19.8 6.7 7.7 1 16.2 0.6 24.8-0.5 8.7-1.2 17.6-3.1 26.5-5.4 8.8-2.4 17.7-5.1 26.6-8 17.7-5.8 35.4-12.4 53.3-18.3 17.9-6 36.1-11.2 55-14.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m586.3 178c6.4-1.6 12.4-2.6 18.2-3.3 2.9-0.4 5.8-0.6 8.6-0.9 2.8-0.1 5.7-0.3 8.5-0.3 5.5-0.2 10.9-0.1 16.4 0.1 21.4 0.8 42 4.1 62.2 7.3l7.2 1 3.2 0.5 3.3 0.3c2.1 0.2 4.4 0.1 6.6 0.2 2.3-0.1 4.6-0.2 6.9-0.4 2.4-0.2 4.7-0.4 7.1-0.8q3.5-0.5 7.1-1.2c4.7-1 9.5-2 14.3-3.3 19.3-5.1 38.3-12.7 59.6-17.5 10.7-2.3 22.2-3.9 34.3-2.6 6.2 0.5 12.2 2 18.2 4 3 1.1 6 2.2 8.8 3.6 1.4 0.7 2.9 1.4 4.2 2.1l4.1 2.4c5.4 3.3 10.3 7.1 14.9 11.1 2.4 2 4.6 4.5 6.9 6.8 2.2 2.4 4.1 5 6.1 7.6 2 2.5 3.6 5.2 5.3 7.9 0.9 1.4 1.6 2.8 2.4 4.1l2.2 4.2 1 2.1 0.9 2.1 1.8 4.3c1.3 2.8 2.2 5.7 3.1 8.6 3.7 11.6 5.6 23.4 6.3 35 0.5 11.6-0.1 23.1-1.9 34.3-1.8 11.2-4.9 22.1-8.8 32.6q-1.6 4-3.2 7.8c-1.1 2.6-2.4 5.1-3.6 7.6-1.2 2.6-2.6 5-4 7.5-1.3 2.4-2.7 4.8-4.2 7.2-5.9 9.5-12.7 18.4-19.9 26.7-7.3 8.3-15.1 16.1-23.4 23-8.3 6.9-17 13.2-26.3 18.3-9.2 5.1-19.1 9.1-29.4 11.3-10.4 2.2-21.4 1.9-31.9-0.8-10.6-2.6-20.5-7.3-30-12.7-18.8-10.9-36.1-24.6-52-38.9-8-7.2-15.5-14.7-22.7-22.4-1-1.2-1.5-1.5-2.2-2.1l-1.8-1.6c-1.5-1-2.6-2.1-4.1-3l-2-1.4c-0.8-0.5-1.5-0.9-2.2-1.4-1.4-0.9-3.1-1.7-4.6-2.7-6.4-3.5-13.6-6.9-22-10.3l-13.1-5.1-7.1-2.8-7.3-3c-5-2-10.2-4.6-15.6-7.2-5.3-2.8-10.9-5.9-16.4-9.8-5.6-4-11.3-8.4-16.5-14.1-5.2-5.6-10.1-12-13.8-19.1l-1.4-2.7-1.2-2.7c-0.8-1.8-1.6-3.6-2.3-5.4-1.2-3.7-2.6-7.5-3.3-11.1l-1.1-5.5-0.7-5.4c-0.6-3.7-0.6-7-0.7-10.5 0-0.9-0.1-1.6-0.1-2.7q0.1-2.1 0.2-4.2c0.1-2.7 0.6-5.7 1.3-8.6q0.2-1.1 0.5-2.2l0.7-2.2q0.7-2.1 1.5-4.3c1.2-2.8 2.7-5.5 4.3-8q1.2-1.8 2.5-3.5c0.5-0.6 0.9-1.2 1.3-1.7l1.4-1.6q1.4-1.5 2.8-2.9c1-1 1.9-1.7 2.9-2.5 0.9-0.8 1.9-1.6 2.9-2.3l2.8-2c0.9-0.6 1.9-1.2 2.8-1.8l2.8-1.5c7.3-3.8 14.1-6 20.4-7.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m293.4 708c1.2 7 1.6 13.7 1.4 20.2-0.1 12.9-3.1 24.7-6.2 36.3-3.3 11.5-7.2 22.7-12.1 33.6-5 10.7-11.1 21.1-18.7 30.6-7.6 9.4-16.4 18.3-26.9 25.9-10.5 7.4-23.5 12.9-37.8 15-7.1 1.1-14.6 1.3-21.8 0.5-7.2-0.9-14.2-2.7-20.3-5.5-6.2-2.7-11.4-6.2-15.9-9.9-4.6-3.7-8.5-7.6-12.4-11.5q-3-3.3-5.3-7.1c-1.5-2.6-2.8-5.3-3.8-8.1-2-5.7-3.3-11.8-4.1-17.9-1.6-12.4-2-25.6-0.4-38.2 1.6-12.7 5.5-24.5 11.6-34.5 6.2-10.1 14.2-18.6 23.7-25.5 9.5-6.8 20.6-11.8 31.5-16.3 11-4.4 21.7-8.5 31.8-13.3 10.4-4.6 20-10.1 32.4-14 3.1-0.9 6.4-1.7 10.1-2.1 3.7-0.5 7.7-0.6 12.1 0.1 4.7 0.8 10.3 3.5 14.5 7.1 1 0.9 2 1.9 2.9 2.9q1.3 1.4 2.5 3c1.5 2 2.9 4.1 3.9 6.1 1.1 2.1 1.9 4 2.8 6 0.7 1.9 1.5 3.9 2 5.7l0.8 2.8 0.6 2.8c0.5 1.8 0.8 3.5 1.1 5.3z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m338.5 460.7c0 13.8-11.1 24.5-24.9 24.5h-4.4v33.7c0 13.8-10.7 24.5-24.5 24.5-13.7 0-24.4-10.7-24.4-24.5v-33.7h-139.9c-5.4 0-10.7-1.4-15.1-5.4-11.2-8.4-12.5-23.5-4-34.2l164.3-204.3c0.5 0 0.5-0.5 0.9-0.9 0.5-0.5 0.9-0.9 1.4-1.8 1.3-0.4 1.7-0.9 2.2-1.3 0.4-0.5 1.3-0.9 1.8-1.4 0.8-0.4 1.3-0.8 2.6-0.8 0.5-0.9 0.9-1.4 1.8-1.4 0.4-0.4 1.3-0.4 2.7-0.9 0.4 0 1.3 0 1.7-0.4 0.9 0 2.3 0 3.1 0 0 0 0.5 0 0.9 0 0.5 0 0.5 0 0.9 0 0.9 0 2.2 0 2.7 0 0.9 0.4 1.3 0.4 2.2 0.4 0.4 0.5 1.8 0.5 2.7 0.9 0.4 0 1.3 0.5 1.8 0.5 0.8 0.9 1.7 1.3 2.2 1.7 0.9 0.5 1.3 0.9 2.2 1.4 0 0 0.4 0 0.4 0.4 0.5 0 1.4 0.5 1.4 0.9 0.9 0.9 1.3 1.3 1.7 1.8 0.5 0.4 0.9 1.3 1.4 1.8 0.4 0.4 0.9 0.9 1.8 2.2 0 0.4 0.4 1.3 0.8 1.8 0.5 0.9 0.5 1.3 0.9 2.6 0 0.5 0.5 1.4 0.5 1.8 0.4 0.9 0.4 1.3 0.4 2.7 0 0.9 0.5 1.3 0.5 2.2q0 0.7 0 1.3v179.5h4.4c13.8 0 24.9 11.1 24.9 24.4zm-78.2-134.1l-88.4 109.7h88.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m904.2 460.7c0 13.8-11.1 24.5-24.9 24.5h-4.4v33.7c0 13.8-10.7 24.5-24.4 24.5-13.8 0-24.5-10.7-24.5-24.5v-33.7h-139.9c-5.4 0-10.7-1.4-15.1-5.4-11.1-8.4-12.5-23.5-4-34.2l164.3-204.3c0.5 0 0.5-0.5 0.9-0.9 0.5-0.5 0.9-0.9 1.4-1.8 1.3-0.4 1.8-0.9 2.2-1.3 0.4-0.5 1.3-0.9 1.8-1.4 0.9-0.4 1.3-0.8 2.6-0.8 0.5-0.9 0.9-1.4 1.8-1.4 0.5-0.4 1.3-0.4 2.7-0.9 0.4 0 1.3 0 1.8-0.4 0.8 0 2.2 0 3.1 0 0 0 0.4 0 0.9 0 0.4 0 0.4 0 0.8 0 0.9 0 2.3 0 2.7 0 0.9 0.4 1.3 0.4 2.2 0.4 0.5 0.5 1.8 0.5 2.7 0.9 0.4 0 1.3 0.5 1.8 0.5 0.9 0.9 1.7 1.3 2.2 1.7 0.9 0.5 1.3 0.9 2.2 1.4 0 0 0.5 0 0.5 0.4 0.4 0 1.3 0.5 1.3 0.9 0.9 0.9 1.3 1.3 1.8 1.8 0.4 0.4 0.9 1.3 1.3 1.8 0.4 0.4 0.9 0.9 1.8 2.2 0 0.4 0.4 1.3 0.9 1.8 0.4 0.9 0.4 1.3 0.9 2.6 0 0.5 0.4 1.4 0.4 1.8 0.4 0.9 0.4 1.3 0.4 2.7 0 0.9 0.5 1.3 0.5 2.2q0 0.7 0 1.3v179.5h4.4c13.8 0 24.9 11.1 24.9 24.4zm-78.2-134.1l-88.4 109.7h88.4z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Planet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m344.2 388.8c-7.2-1.3-12-8.2-10.7-15.5l4.5-25.3c1.3-7.2 8.2-12.1 15.5-10.8 7.2 1.3 12 8.2 10.7 15.5l-4.5 25.3c-1.3 7.3-8.2 12.1-15.5 10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m655.3 399c-7.3 1-14-4-15.1-11.3l-3.7-25.5c-1-7.3 4-14 11.3-15.1 7.3-1 14.1 4 15.1 11.3l3.7 25.5c1.1 7.3-4 14-11.3 15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m384.7 284.2c-5.1-5.3-4.8-13.8 0.6-18.8l10.1-9.4c5.4-5.1 13.9-4.8 18.9 0.6 5 5.4 4.7 13.8-0.7 18.9l-10.1 9.4c-5.4 5-13.8 4.7-18.8-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m417 513.9c-5.4 5-13.8 4.7-18.8-0.7l-9.5-10.1c-5-5.4-4.7-13.8 0.7-18.8 5.4-5.1 13.8-4.8 18.8 0.6l9.5 10.1c5 5.4 4.7 13.8-0.7 18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m645.9 317.1l-14.8 10.3c-2 1.4-4.7 0.9-6-1.1l-18.2-26.1c-1.4-2-0.9-4.7 1-6l14.8-10.3c2-1.4 4.7-0.9 6 1l18.2 26.2c1.4 1.9 0.9 4.6-1 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m535.6 534.2c-2.5-6.9 1.1-14.6 8-17.1l13-4.7c6.9-2.5 14.6 1.1 17.1 8 2.5 7-1.1 14.6-8 17.1l-13 4.7c-6.9 2.5-14.6-1.1-17.1-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m349.1 359.6c15-83.7 94.9-139.4 178.5-124.4 83.7 14.9 139.4 94.8 124.4 178.5-14.9 83.6-94.8 139.3-178.5 124.4-83.6-14.9-139.3-94.9-124.4-178.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m486 270.2c4.5 5.6 6.9 12.9 7.2 20.4 0.4 7.5-1.6 15.1-5.2 21.7-3.8 6.6-10 12.3-17.5 14.5-7.3 2.2-15.1 1.7-21.7-1.1 7.2 0.1 14-1.1 19.8-3.8 2.9-1.4 5.6-3.2 7.8-5.4 2.3-2.1 4.1-4.8 5.7-7.5 0.8-1.4 1.5-2.9 2.2-4.4 0.6-1.5 1.3-3 1.7-4.6 1.1-3 1.6-6.3 2-9.5 0.7-6.6 0-13.5-2-20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m445.7 309.1c-3.5-3.6-5.5-8.7-5.8-13.9-0.4-5.3 0.9-10.7 3.5-15.3 2.6-4.7 7.2-8.7 12.5-10.1 5.2-1.5 10.6-0.9 15 1.5-4.9 0.4-9.4 1.4-13.2 3.4-3.7 1.9-6.4 4.9-8.5 8.5-4.2 7.5-5.5 16.2-3.5 25.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m501.3 478.8c1.9 3 2.5 6.8 2 10.5-0.6 3.7-2.3 7.3-5 10.1-2.6 2.8-6.6 4.7-10.5 4.7-3.8 0.1-7.4-1.3-10.1-3.6 3.5 0.5 6.8 0.5 9.7-0.2 2.9-0.7 5.3-2.2 7.3-4.3 2.1-2.2 3.7-4.7 4.9-7.6 1-2.9 1.6-6.1 1.7-9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m480.3 495.1c-1.6-1.9-2.2-4.6-2-7.3 0.3-2.7 1.6-5.3 3.4-7.2 1.9-2.1 4.9-3.4 7.7-3.3 2.7 0.1 5.2 1.2 6.9 3.1-2.5-0.1-4.7 0.1-6.5 0.7-1.8 0.6-3.2 1.6-4.5 2.9-2.6 2.8-4.3 6.2-5 11.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m406.8 438.6c3.6 0.4 6.9 2.5 9.3 5.6 2.3 3.1 3.3 7.4 2.6 11.4-0.6 4.3-3.7 7.9-7 9.6-3.4 1.8-7.1 2.4-10.6 1.7 2.9-2 5.5-3.9 7.5-6 2-2 3.2-4.1 3.5-6.5 0.4-2.4 0.3-5.1-0.6-7.7-0.9-2.6-2.5-5.3-4.7-8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m399.7 461.7c-2.6 0.1-5.2-1.2-7-3.4-1.8-2.2-2.6-5.3-2.1-8.3 0.4-3.2 2.9-5.9 5.3-7 2.6-1.2 5.2-1.4 7.7-0.5-1.8 1.8-3.4 3.2-4.6 4.7-1.1 1.5-1.6 2.7-1.8 3.9-0.2 1.5-0.3 3 0.1 4.7 0.4 1.7 1.2 3.6 2.4 5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m580.4 283.7c2.4 2.7 3.6 6.4 3.2 10.3-0.3 3.9-2.3 7.8-5.6 10.3-3.3 2.8-8 3.4-11.6 2.5-3.7-0.9-6.9-2.9-9.1-5.7 3.6 0.3 6.7 0.7 9.6 0.4 2.9-0.2 5.1-1 6.9-2.5 2-1.5 3.6-3.6 4.7-6.1 1.1-2.6 1.7-5.7 1.9-9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m559.8 296.3c-2.1-1.7-3.1-4.4-3-7.2 0.1-2.9 1.5-5.8 3.9-7.7 2.5-2.1 6.1-2.5 8.7-1.7 2.7 0.8 4.8 2.4 6.1 4.8-2.6 0.1-4.8 0.1-6.6 0.5-1.8 0.3-3 0.9-4 1.7-1.1 0.9-2.2 2-3 3.5-0.9 1.6-1.5 3.5-2.1 6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m503 388.6c-3.5-18.5 8.5-36.3 26.9-39.8 18.4-3.5 36.2 8.6 39.7 27.1 3.6 18.5-8.5 36.3-26.9 39.8-18.4 3.6-36.1-8.6-39.7-27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m503 388.6c-3.5-18.5 8.5-36.3 26.9-39.8 18.4-3.5 36.2 8.6 39.7 27.1 3.6 18.5-8.5 36.3-26.9 39.8-18.4 3.6-36.1-8.6-39.7-27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m515.8 396.2c1.5 7.9 5.9 14.6 12 19-12.3-3.2-22.2-13.2-24.8-26.6-3.5-18.5 8.5-36.3 26.9-39.8 15.6-3 30.7 5.2 37.1 19-6.9-6.5-16.8-9.7-26.8-7.8-16.7 3.2-27.6 19.4-24.4 36.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m578.2 360.1c5.3 7 8.1 16 8.3 25.1 0.3 9.2-2.2 18.4-6.6 26.4-4.5 8.1-12 15.1-21 17.7-8.9 2.9-18.4 2.5-26.6-0.6 8.8 0.3 17.3-0.9 24.7-4.3 1.9-0.8 3.5-1.9 5.3-2.9 1.5-1.2 3.2-2.2 4.5-3.7 3-2.6 5.2-6 7.3-9.5 0.9-1.7 1.9-3.6 2.7-5.4 0.7-1.9 1.6-3.8 2.1-5.8 1.4-3.8 1.9-7.9 2.4-12 0.7-8.2-0.3-16.8-3.1-25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m599.6 342.3c-2.6-6.5 0.6-13.9 7-16.5 6.5-2.6 13.9 0.6 16.5 7.1 2.6 6.5-0.5 13.9-7 16.5-6.5 2.6-13.9-0.6-16.5-7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m599.6 342.3c-2.6-6.5 0.6-13.9 7-16.5 6.5-2.6 13.9 0.6 16.5 7.1 2.6 6.5-0.5 13.9-7 16.5-6.5 2.6-13.9-0.6-16.5-7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m604.8 344.1c1.2 2.8 3.3 5 5.8 6.2-4.7-0.3-9.1-3.3-11-8-2.6-6.5 0.6-13.9 7-16.5 5.5-2.2 11.6-0.3 15 4.3-3-1.9-6.9-2.4-10.4-0.9-5.9 2.3-8.7 9-6.4 14.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m625.1 326.5c2.6 2.1 4.4 5.2 5.2 8.5 0.8 3.4 0.6 7-0.5 10.4-1.1 3.3-3.4 6.5-6.6 8.1-3.2 1.7-6.8 2.1-10 1.4 3.2-0.7 6.2-1.9 8.6-3.6 2.4-1.8 3.9-4.2 4.9-7 1.9-5.7 1.4-11.9-1.6-17.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m566.8 461c-5.3-8.5-2.7-19.6 5.7-24.9 8.5-5.2 19.6-2.6 24.8 5.9 5.3 8.5 2.7 19.6-5.7 24.8-8.4 5.3-19.5 2.6-24.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m566.8 461c-5.3-8.5-2.7-19.6 5.7-24.9 8.5-5.2 19.6-2.6 24.8 5.9 5.3 8.5 2.7 19.6-5.7 24.8-8.4 5.3-19.5 2.6-24.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m574.6 462.3c2.2 3.6 5.7 6.1 9.5 7.1-6.7 0.7-13.5-2.3-17.3-8.4-5.3-8.5-2.7-19.6 5.7-24.9 7.2-4.4 16.2-3.2 22 2.4-4.7-1.9-10.1-1.6-14.7 1.2-7.7 4.8-10 14.9-5.2 22.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m598.6 432.6c3.9 2.5 7 6.4 8.8 10.9 1.9 4.4 2.4 9.4 1.7 14.2-0.7 4.9-3.1 9.7-7 12.7-3.8 3.2-8.6 4.7-13.2 4.8 4.4-1.4 8.4-3.7 11.5-6.7 3-3 4.8-7 5.4-11.3 0.7-4.3 0.4-8.7-0.9-12.9-1.2-4.2-3.3-8.2-6.3-11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m424.4 370.3c0.4 13.8-12 25.5-27.7 25.9-15.7 0.5-28.7-10.4-29.1-24.3-0.4-13.8 11.9-25.5 27.6-25.9 15.7-0.5 28.8 10.4 29.2 24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m424.4 370.3c0.4 13.8-12 25.5-27.7 25.9-15.7 0.5-28.7-10.4-29.1-24.3-0.4-13.8 11.9-25.5 27.6-25.9 15.7-0.5 28.8 10.4 29.2 24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m378.5 377.6c0.3 7.5 4.6 14.1 11.2 18.1-12.4-2.4-21.8-12-22.1-23.8-0.5-13.8 11.9-25.5 27.6-26 11.3-0.3 21.3 5.3 26.1 13.6-4.7-3.6-10.9-5.7-17.7-5.5-14.2 0.4-25.4 11-25.1 23.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m421 349.2c6.4 2.5 11.9 7.8 14.8 14.7 1.5 3.4 2 7.2 1.9 10.9-0.1 3.8-1.1 7.4-2.4 10.9-1.8 3.4-3.9 6.6-6.7 9.1-2.8 2.4-5.8 4.5-9.1 5.9-6.4 3-13.4 4.4-20.3 4.1 6.5-2.3 12.6-4.9 18-8.4 5.4-3.4 9.9-7.9 12.3-13.2 1.1-2.7 2.1-5.7 2.3-8.7 0.3-3 0.1-6.1-0.7-9-1.5-6-5.2-11.6-10.1-16.3z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Stars"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m529.6 818.7l1.9-8.1 1.8 8.1 8.1 2-8.1 1.5-1.8 8.6-1.8-8.6-8.1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m348 518.1l1.9-8 1.8 8 8.1 2-8.1 1.5-1.8 8.6-1.9-8.6-8.1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m799 514.6l1.9-8.1 1.8 8.1 8.1 2-8.1 1.5-1.8 8.5-1.8-8.5-8.1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m883.2 744.6l1.1-4.5 1 4.5 4.5 1.1-4.5 0.8-1 4.8-1-4.8-4.6-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m821.1 189.2l1-4.5 1.1 4.5 4.5 1.1-4.5 0.9-1.1 4.8-1-4.8-4.5-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m910.5 331.5l1-4.5 1.1 4.5 4.5 1.1-4.5 0.8-1.1 4.8-1-4.8-4.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m217.7 395.6l1-4.5 1 4.5 4.6 1.1-4.6 0.9-1 4.7-1-4.7-4.5-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m101.9 768.3l1.1-4.5 1 4.5 4.5 1.1-4.5 0.8-1 4.8-1.1-4.8-4.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m854.6 650.4l1.1-4.5 1 4.5 4.5 1.2-4.5 0.8-1 4.8-1-4.8-4.6-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m235.9 795.9l1-4.5 1 4.5 4.6 1.1-4.6 0.8-1 4.8-1-4.8-4.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m395.7 208.6l1-4.5 1.1 4.5 4.5 1.1-4.6 0.9-1 4.8-1-4.8-4.5-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m664.3 342.7l1.1-4.5 1 4.5 4.5 1.1-4.5 0.9-1 4.8-1-4.8-4.6-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m303.8 702.4l1-4.5 1.1 4.5 4.5 1.1-4.6 0.9-1 4.8-1-4.8-4.5-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m103 851.5c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m758.3 691.4c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m770.7 503.3c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m678.7 406.3c1.7 0 1.7 2.7 0 2.7-1.7 0-1.7-2.7 0-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m272.7 869.3c1.6 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m218.7 793c1.7 0 1.7 2.7 0 2.7-1.7 0-1.7-2.7 0-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m354.3 758.1c1.7 0 1.7 2.7 0 2.7-1.7 0-1.7-2.7 0-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m603.3 793c1.7 0 1.7 2.7 0 2.7-1.7 0-1.7-2.7 0-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m820.9 708.6c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m765.8 563.1c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m542.5 790.4c1.2 0 1.2 1.9 0 1.9-1.2 0-1.2-1.9 0-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m255 213.3c1.2 0 1.2 1.9 0 1.9-1.2 0-1.2-1.9 0-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m616.1 681.8c1.2 0 1.2 1.9 0 1.9-1.2 0-1.2-1.9 0-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m257.3 801.7c1.2 0 1.2 1.8 0 1.8-1.2 0-1.2-1.8 0-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m495.3 577.2c1.2 0 1.2 1.8 0 1.8-1.2 0-1.2-1.8 0-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m696.5 587.9c3.3 0 3.3 5 0 5-3.2 0-3.2-5 0-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m351.2 238.3l1.8-8 1.9 8 8 2-8.1 1.5-1.8 8.6-1.8-8.6-8.1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m692.5 307l1.8-8 1.9 8 8 2-8.1 1.5-1.8 8.6-1.8-8.6-8.1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m101.1 512.2l1.9-8 1.8 8 8.1 2-8.1 1.5-1.8 8.6-1.9-8.6-8.1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m820.3 104.6l1.8-8.1 1.9 8.1 8.1 2-8.1 1.5-1.9 8.6-1.8-8.6-8.1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m524.9 124.8l1-4.5 1.1 4.5 4.5 1.1-4.5 0.8-1.1 4.8-1-4.8-4.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m107.5 284.6l1-4.5 1 4.5 4.6 1.1-4.6 0.8-1 4.8-1-4.8-4.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m186.3 277.7c1.7 0 1.7 2.7 0 2.7-1.7 0-1.7-2.7 0-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m86.3 748.9c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m194.2 703.5c1.7 0 1.7 2.7 0 2.7-1.7 0-1.7-2.7 0-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m87.6 370.5c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m194.2 172.7c1.7 0 1.7 2.7 0 2.7-1.7 0-1.7-2.7 0-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m366.4 105.3c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m313.6 575.6c1.2 0 1.2 1.9 0 1.9-1.2 0-1.2-1.9 0-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m312.7 815.3c1.2 0 1.2 1.8 0 1.8-1.2 0-1.2-1.8 0-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m792.5 267.4l1.1-4.6 1 4.6 4.5 1.1-4.5 0.8-1 4.8-1.1-4.8-4.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m894.1 504.8l1-4.5 1 4.5 4.6 1.2-4.6 0.8-1 4.8-1-4.8-4.6-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m775.3 273c1.7 0 1.7 2.6 0 2.6-1.6 0-1.6-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m641 141.5c1.2 0 1.2 1.9 0 1.9-1.2 0-1.2-1.9 0-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m443.1 901.6c1.2 0 1.2 1.9 0 1.9-1.2 0-1.2-1.9 0-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m869.3 295.2c1.2 0 1.2 1.9 0 1.9-1.2 0-1.2-1.9 0-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m682.1 249.5c1.2 0 1.2 1.8 0 1.8-1.2 0-1.2-1.8 0-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m684.8 107c1.2 0 1.2 1.8 0 1.8-1.2 0-1.2-1.8 0-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m424.1 542.5c3.3 0 3.3 5.1 0 5.1-3.2 0-3.2-5.1 0-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m768.3 413.5c3.2 0 3.2 5 0 5-3.3 0-3.3-5 0-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m198.5 416c3.2 0 3.2 5.1 0 5.1-3.3 0-3.3-5.1 0-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m892.3 431.2c3.2 0 3.2 5.1 0 5.1-3.3 0-3.3-5.1 0-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m163.3 662.1c3.3 0 3.3 5 0 5-3.2 0-3.2-5 0-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m295 168.6l1-4.5 1.1 4.5 4.5 1.1-4.5 0.9-1.1 4.8-1-4.8-4.5-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m542.4 644.1l1-4.5 1.1 4.5 4.5 1.2-4.5 0.8-1.1 4.8-1-4.8-4.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m684.4 863.9c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m597.2 851.5c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m629.8 498.9l1-4.5 1 4.5 4.6 1.1-4.6 0.8-1 4.8-1-4.8-4.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m785.3 771.6l1-4.6 1 4.6 4.6 1.1-4.6 0.8-1 4.8-1-4.8-4.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m826.7 886.2l1-4.5 1 4.5 4.5 1.1-4.5 0.8-1 4.8-1-4.8-4.6-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m644.4 247.8c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m791.9 833c1.2 0 1.2 1.9 0 1.9-1.2 0-1.2-1.9 0-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m141.1 541.4l1.1-4.5 1 4.5 4.5 1.1-4.5 0.9-1 4.8-1-4.8-4.6-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m84.2 639.9c1.7 0 1.7 2.6 0 2.6-1.7 0-1.7-2.6 0-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m409.1 432.4c1.7 0 1.7 2.7 0 2.7-1.7 0-1.7-2.7 0-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m312.7 286.8c1.2 0 1.2 1.9 0 1.9-1.2 0-1.2-1.9 0-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m160.9 123.4c3.2 0 3.2 5 0 5-3.3 0-3.3-5 0-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m758.7 179.7c3.2 0 3.2 5 0 5-3.3 0-3.3-5 0-5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m735.3 881.7c-11.4 0-22.9-1.5-34.4-4.6-28.5-7.6-50.3-24.7-63.2-49.4-15.1-28.9-14.8-61.6-8.2-79.7l5.6 2.1c-6.3 17.4-5.7 48.7 7.9 74.8 12.1 23.2 32.6 39.3 59.4 46.4 38.5 10.2 77.6 2.2 107.5-21.9 33.1-26.9 49.9-69.7 47.2-120.5-2.6-50.8-26.1-112.1-50.9-177.1-23.9-62.7-48.6-127.5-53.8-183.5-5.4-58.1 10.6-110 46.1-150 43.6-49 115.1-77.2 201.4-79.3l0.2 6c-84.7 2.1-154.7 29.5-197.1 77.3-34.4 38.7-49.9 89-44.6 145.5 5.1 55.1 29.6 119.5 53.4 181.8 25 65.5 48.6 127.3 51.3 179 2.8 52.8-14.8 97.3-49.4 125.4-22.5 18.2-49.9 27.7-78.4 27.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m669.7 641.6q0-0.1 0 0c1.6-0.6 14.7 3.8 18.1 6.6 8.1 6.4 31.7 53.2 30.6 57.1-4.4 15.7-61.9 104.4-67.7 102.5-2.3-0.8-31.2-12.2-35.5-15.6q-0.3-0.2-0.4-0.3c-2.9-3.1-39.4-79.4-38.8-80.8 0.6-1.4 91.3-68.6 93.7-69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m669.7 641.6q0-0.1 0 0c1.6-0.6 14.7 3.8 18.1 6.6 8.1 6.4 31.7 53.2 30.6 57.1-4.4 15.7-61.9 104.4-67.7 102.5-2.3-0.8-31.2-12.2-35.5-15.6q-0.3-0.2-0.4-0.3c-2.9-3.1-39.4-79.4-38.8-80.8 0.6-1.4 91.3-68.6 93.7-69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m669.7 641.6c6.3 10.2 30.1 54.3 30.1 55.5-0.1 1.3-69.7 78.7-84.6 95.1q-0.3-0.2-0.4-0.3c-2.9-3.1-39.4-79.4-38.8-80.8 0.6-1.4 91.3-68.6 93.7-69.5z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m368.6 648.9c0 0-70.8 9.8-70.9 9.8-13.5 2-25.4 3.4-31.6 3.6q-0.1 0-0.1 0c-2.4 0.1-3.9 0-4.3-0.4q-0.1 0-0.1 0c-3.4-3.7-22.1-111.4-21.5-115.4 0.6-3.9 12-2.5 16.1 1.1 4.1 3.6 29.7 41.6 29.7 41.6l70.9-9.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m251.2 664l-1-5.6q0.9-0.2 1.7-0.8c2.5-1.7 3.1-5.1 1.4-7.6-1.2-1.8-3.2-2.6-5.2-2.4l-1-5q1-0.3 1.8-0.8c2.5-1.8 3.2-5.2 1.4-7.7-1.2-1.8-3.2-2.6-5.2-2.3l-1-5.1q1-0.2 1.8-0.8c2.6-1.7 3.2-5.2 1.5-7.7-1.3-1.8-3.4-2.6-5.4-2.3l-0.9-5q1-0.3 1.9-0.9c2.5-1.7 3.1-5.1 1.4-7.7-1.3-1.7-3.4-2.6-5.4-2.3l-1-5q1.1-0.2 2-0.8c2.5-1.8 3.1-5.2 1.4-7.7-1.3-1.8-3.4-2.7-5.4-2.3l-1-5q1.1-0.2 2-0.9c2.5-1.7 3.2-5.2 1.4-7.7-1.2-1.8-3.4-2.6-5.5-2.3l-0.9-5q1.1-0.2 2.1-0.9c2.5-1.7 3.1-5.1 1.4-7.6-1.3-1.9-3.5-2.7-5.6-2.3l-0.9-4.8 11.1-1.2 21.6 115.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m284.7 657.5c-2-11.3-12.8-20.6-24.3-21.2-0.1 0-0.2-0.3 0-0.4 6-0.7 11.7 1.8 16 5 4.4 3.4 8.3 9.7 8.6 16.6 0 0.2-0.3 0.3-0.3 0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m297.9 654.2c-1-4.4-1.8-8.8-2.6-13.2-1.2-7.7-2.3-15.5-3.3-23.2-1.1-7.8-2.3-15.7-2.9-23.5 0-0.3 0.4-0.4 0.5-0.1 1 4.4 1.7 8.8 2.4 13.2q2 11.6 3.8 23.1c1.2 7.8 2.3 15.7 2.8 23.6 0 0.4-0.6 0.5-0.7 0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m303.9 652.5c-1-4.4-1.9-8.8-2.6-13.2-1.2-7.7-2.3-15.5-3.4-23.2-1-7.8-2.2-15.7-2.8-23.5 0-0.3 0.4-0.4 0.5-0.1 0.9 4.4 1.7 8.8 2.4 13.2q2 11.5 3.7 23.1c1.2 7.8 2.4 15.7 2.9 23.6 0 0.4-0.6 0.5-0.7 0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m318.9 655.8l-8-69.8c0 0 6.9-7.4 20.2-9.7 29.6-5.1 83.7-6.9 115.2-1.4 26.5 4.7 110.9 83.9 124.2 94.4 4.9 3.8 16.2-3.1 16.2-3.1l38.4 78.7c0 0-30.3 20.3-60.3 2.7-37-21.7-112.9-98.2-127.9-101.3-13.5-2.8-71.6 10.7-100.9 14.3-10.2 1.3-17.1-4.8-17.1-4.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m328.4 649.7c-0.9-4.4-1.5-8.8-2-13.2-1-7.8-1.8-15.6-2.5-23.3-0.7-7.9-1.6-15.8-1.9-23.7 0-0.2 0.4-0.3 0.5 0 0.8 4.4 1.3 8.8 1.9 13.3q1.5 11.6 2.8 23.2c0.9 7.9 1.7 15.8 1.9 23.7 0 0.4-0.6 0.5-0.7 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m443.6 613.6c-1 3.5-1.8 7-2.5 10.6-0.2 0.9-0.3 1.8-0.5 2.8l-0.5 2.7c-0.3 1.8-0.6 3.6-0.9 5.5-0.3 1.8-0.7 3.7-1 5.5-0.4 1.9-0.7 3.8-1.3 5.6-0.4-1.8-0.7-3.8-1-5.7q-0.2-2.8-0.3-5.7c0-1.9 0.1-3.9 0.2-5.8 0.2-1.9 0.5-3.8 0.8-5.7 0.8-3.8 1.9-7.6 3.7-11.1 0.8-1.8 1.9-3.5 3.1-5 1.3-1.5 2.7-3 4.6-3.8-2.3 3.1-3.4 6.6-4.4 10.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m443.7 606.4c-12.5-7.2-18.4-20.2-13.3-29 5.1-8.9 19.3-10.2 31.7-3 12.5 7.2 18.5 20.2 13.4 29-5.1 8.8-19.4 10.2-31.8 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m443.7 606.4c-12.5-7.2-18.4-20.2-13.3-29 5.1-8.9 19.3-10.2 31.7-3 12.5 7.2 18.5 20.2 13.4 29-5.1 8.8-19.4 10.2-31.8 3z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m625.1 744.9c0 0-30.3 20.3-60.3 2.7-37-21.7-112.9-98.2-127.9-101.2-13.5-2.9-71.6 10.7-100.9 14.2-10.2 1.3-17.1-4.8-17.1-4.8l-7.4-64 293.6 112.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m474.6 737.2c0 0 15.3 69.9 15.3 69.9 3 13.4 5.4 25.1 6.1 31.3q0 0.1 0 0.1c0.2 2.3 0.2 3.9-0.1 4.3q0 0.1 0 0.2c-3.4 3.5-109.3 30.6-113.3 30.2-4.1-0.2-3.5-11.7-0.2-16 3.3-4.4 39.2-32.9 39.2-32.9l-14.6-69.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m498.7 853.1l-5.4 1.5q-0.3-0.9-0.9-1.7c-1.9-2.3-5.4-2.7-7.8-0.8-1.6 1.3-2.3 3.4-1.9 5.4l-5 1.3q-0.3-0.9-0.9-1.7c-1.9-2.4-5.4-2.7-7.8-0.8-1.6 1.3-2.3 3.5-1.9 5.4l-4.9 1.4q-0.3-1-1-1.8c-1.9-2.4-5.4-2.7-7.7-0.8-1.7 1.4-2.4 3.5-1.9 5.5l-5 1.3q-0.3-0.9-1-1.8c-1.9-2.4-5.4-2.7-7.7-0.8-1.7 1.4-2.4 3.6-1.9 5.5l-5 1.4q-0.3-1-1-1.9c-1.9-2.4-5.4-2.7-7.7-0.8-1.7 1.4-2.4 3.6-1.9 5.6l-4.9 1.3q-0.3-1-1-1.9c-2-2.4-5.4-2.7-7.8-0.8-1.7 1.4-2.4 3.6-1.9 5.7l-4.9 1.3q-0.3-1.1-1-2c-2-2.4-5.4-2.8-7.8-0.8-1.7 1.4-2.4 3.7-1.8 5.7l-4.7 1.3-2.1-11 113.4-30.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m489.7 820.2c-11.1 2.9-19.5 14.4-19.2 25.9 0 0.1-0.4 0.2-0.4 0-1.2-5.9 0.9-11.8 3.7-16.3 3-4.7 9.1-9 15.9-9.9 0.2 0 0.3 0.3 0 0.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m485.4 807.3c-4.3 1.4-8.6 2.5-13 3.6-7.6 1.8-15.2 3.5-22.8 5.2-7.7 1.6-15.5 3.4-23.3 4.6-0.3 0-0.4-0.4-0.1-0.4 4.3-1.4 8.7-2.4 13-3.5q11.4-2.8 22.8-5.5c7.7-1.8 15.4-3.6 23.2-4.6 0.4-0.1 0.6 0.5 0.2 0.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m483.2 801.5c-4.3 1.3-8.6 2.5-12.9 3.6-7.6 1.8-15.3 3.5-22.9 5.1-7.7 1.7-15.4 3.5-23.2 4.7-0.3 0-0.4-0.4-0.1-0.5 4.2-1.3 8.6-2.4 12.9-3.4q11.4-2.9 22.8-5.5c7.7-1.8 15.4-3.6 23.2-4.7 0.5 0 0.6 0.5 0.2 0.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m630.8 755.5c-36.1 30.5-69.8 4.2-69.8 4.2 0 0-62.3-31.1-85.3-34.9 0 0 8.1 27.9 10.2 40.2 1.5 8.1 0.2 22.8 0.2 22.8l-71.6 13.3c0 0-7.6-9.6-10.2-20.6-5.7-24.7-8.8-66.9-6.4-97 1.5-18.6 28.5-38 40.3-37.7 34.3 0.9 118.2 47.4 118.2 47.4 0 0 0.9-9.5 2.1-9.8 2.3-0.6 32.2-8.8 32.2-8.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m558.7 681c-0.6 7.2-2.1 14.4-3.8 21.3 0 0.3-0.4 0.3-0.3 0 1-7.1 2-14.3 3.4-21.4 0.1-0.5 0.8-0.4 0.7 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m590.8 670.8c0.1 0 0.2 0.3 0.1 0.3-5.5 1.8-10.3 3.8-15.3 6-2.3 1-15.1 7.4-13.1 11.7 0.3 0.8 1.1 0.9 2.2 0.7 1.3-0.2 2.7-1.3 3.9-1.9q3.9-2.2 8-3.9c5.1-2.2 10.3-3.9 15.7-4.9 0.2-0.1 0.2 0.2 0 0.3-7.2 2.3-14.3 4.9-21.2 8.4-3.3 1.7-8 5.3-9.4 1.5-1.5-3.9 6.6-9.4 8.9-10.7 6.3-3.5 13.4-5.9 20.2-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m562.1 688.3q-1.4 1.3-3.1 2.4c-0.8 0.6-1.7 1.2-2.6 1.4-0.2 0.1-0.3-0.2-0.2-0.3 0.6-1 1.6-1.6 2.4-2.2 1-0.8 1.9-1.6 2.9-2.3 0.6-0.5 1.2 0.5 0.6 1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m419.4 788.4c4.2-1.3 8.4-2.4 12.8-3.3 7.5-1.7 15-3.3 22.5-4.7 7.6-1.5 15.3-3.2 23-4.2 0.2-0.1 0.3 0.3 0.1 0.4-4.3 1.2-8.6 2.2-12.9 3.2q-11.2 2.6-22.5 5.1c-7.5 1.6-15.2 3.2-22.9 4.1-0.4 0.1-0.5-0.5-0.1-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m440.8 681.7c1.4 2.1 3 4.2 4.6 6.3 3.2 4.1 6.6 8.1 10 12.1 3.4 4 6.9 8 10.3 12 3.4 4.1 6.9 8.2 10 12.7-4.6-2.9-8.9-6.2-12.9-9.8-4-3.6-7.8-7.4-11.3-11.5-3.5-4.2-6.8-8.5-9.5-13.3q-1-1.8-1.9-3.6c-0.6-1.3-1.1-2.5-1.6-3.8-0.9-2.6-1.7-5.4-1.3-8.2 0.7 2.7 2.1 4.9 3.6 7.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m437 680c-13 6.3-27.1 3.9-31.5-5.2-4.5-9.2 2.3-21.7 15.3-28 12.9-6.3 27-4 31.5 5.2 4.4 9.1-2.4 21.7-15.3 28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m437 680c-13 6.3-27.1 3.9-31.5-5.2-4.5-9.2 2.3-21.7 15.3-28 12.9-6.3 27-4 31.5 5.2 4.4 9.1-2.4 21.7-15.3 28z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m664.4 668.6c-25.7-36.7-39.9-67.6-39.2-81.3 0.6-12 6.8-47.2 18-66.3 3.4-5.8 39.1 8.2 38.2 15.2-0.9 7.2-11.5 44.1-12.5 53.3-0.6 5.2 10 58.4 12.6 70.5 4.4 20.1-5.7 24.9-17.1 8.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m643.2 521c0 0-2.6-13.4-2.5-21.6 0.2-8.3 8.3-35.2 15.1-33.7 6.8 1.6 0.8 20.5 0.3 25.5-0.4 4.9 0.6 5.9 2.5 3.9-5.2 9.6-12.8 20.9-15.4 25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m643.2 521c2.7-5.1 18.4-29.1 25.8-47.5 3.2-8 1.1-21.2 7.5-20.6 5.7 0.6 6.3 9.9 6.3 9.9 0 0 4.3 1.6 7 8.9 0 0 3.9 2.2 4.4 10.1 0 0 1.9 1.9 2.2 5.4 1.4 17.7-8.1 34.9-15 49z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m675 498.3c5.6-10.2 8.8-23.7 8-35.4 0-0.2-0.3-0.2-0.3 0-0.6 6.4-0.9 12.7-2.4 18.9-1.3 5.7-3.5 11-5.6 16.4-0.1 0.3 0.1 0.4 0.3 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m685.1 504.3c1.8-5.4 4.8-14.9 4.5-32.6 0 0 0.1-0.1 0.1 0 1.7 11.5 0.1 22.1-4.3 32.7-0.1 0.3-0.4 0.3-0.3-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m690.8 507.5c2.6-9.3 3-15.5 3.4-25.6 0-0.1 0.1-0.1 0.1 0 0.8 11.5-0.2 15.8-3.2 25.7-0.1 0.4-0.4 0.3-0.3-0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m682.9 550.2c-1.6 6.3-12 36.8-12.1 40.2 0 3.4 10 60.1 12.3 73.7 2.3 13.6-3.4 25.2-17 9.2-13.5-16.1-38.5-64-41.3-77.1-2.9-13.1 4.5-59.3 8.4-65.9 4-6.7 10-9.3 10-9.3l38.2 15.2c0 0 3 7.7 1.5 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m666.1 673.3c-10.3-12.2-27.1-42.7-35.9-62.5l46.4 15.4c2.6 15.5 5.4 31.5 6.5 37.9 2.3 13.6-3.4 25.2-17 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m679.5 546.1q-4.6-1.6-9.2-3.3-8.1-3.1-16-6.4c-5.4-2.1-10.8-4.3-16.1-6.6-0.2-0.1-0.2-0.3 0-0.2 3.1 1 6.2 2.2 9.3 3.4q8 3 16.1 6.2c5.4 2.1 10.8 4.2 16 6.6 0.3 0.1 0.2 0.4-0.1 0.3z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m591.6 661.8c10.3-6.4 28.9-13.4 43.8-14.8 14.1-1.3 53.6 11.3 56.6 12.5 11.9 5.1 18.1 18 10.4 34.2-10.8 22.5-39.6 47.4-57.1 57.8-7.6 4.5-14.2 2.6-14.2 2.6l-47-84c0 0 2.5-5.2 7.5-8.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m579 670.7c-0.2-1.2 6.7-4.8 7.7-4.5 1 0.4 49.3 87.6 49.4 88.2 0.1 0.7-8.3 4.8-8.9 4-0.6-0.8-48-86-48.2-87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m579 670.7c-0.2-1.2 6.7-4.8 7.7-4.5 1 0.4 49.3 87.6 49.4 88.2 0.1 0.7-8.3 4.8-8.9 4-0.6-0.8-48-86-48.2-87.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m634.6 688.3l-8.2-42 37.1-0.5 8.3 42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m634.6 688.3l-8.2-42 37.1-0.5 8.3 42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m634.6 688.3l-1-5.3 37.1-0.4 1.1 5.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m656.3 653.2c-1.4 0-2.6-1-2.9-2.2-0.2-1.2 0.7-2.1 2-2.2 1.3 0 2.6 1 2.8 2.2 0.3 1.2-0.6 2.1-1.9 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m648.4 653.2c-1.3 0.1-2.6-0.9-2.8-2.1-0.3-1.2 0.6-2.2 2-2.2 1.3 0 2.5 1 2.8 2.2 0.2 1.1-0.7 2.1-2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m640.5 653.3c-1.3 0-2.6-0.9-2.8-2.1-0.2-1.2 0.7-2.2 2-2.2 1.3 0 2.6 1 2.8 2.1 0.2 1.2-0.6 2.2-2 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m657.6 659.8c-1.3 0.1-2.6-0.9-2.8-2.1-0.3-1.2 0.6-2.1 1.9-2.2 1.4 0 2.6 1 2.9 2.2 0.2 1.2-0.7 2.1-2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m649.7 659.9c-1.3 0.1-2.6-0.9-2.8-2.1-0.2-1.2 0.6-2.2 2-2.2 1.3 0 2.6 1 2.8 2.2 0.2 1.1-0.7 2.1-2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m641.8 660c-1.3 0-2.5-0.9-2.8-2.1-0.2-1.2 0.7-2.2 2-2.2 1.3 0 2.6 1 2.8 2.1 0.3 1.2-0.6 2.2-2 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m658.9 666.5c-1.3 0.1-2.6-0.9-2.8-2.1-0.3-1.2 0.6-2.1 1.9-2.2 1.4 0 2.6 1 2.9 2.2 0.2 1.2-0.7 2.1-2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m651 666.6c-1.3 0.1-2.6-0.9-2.8-2.1-0.2-1.2 0.7-2.2 2-2.2 1.3 0 2.6 1 2.8 2.2 0.2 1.1-0.6 2.1-2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m643.2 666.7c-1.4 0-2.6-0.9-2.9-2.1-0.2-1.2 0.7-2.2 2-2.2 1.3 0 2.6 1 2.8 2.1 0.3 1.2-0.6 2.2-1.9 2.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m686.8 654.4q0.1-0.1 0.2-0.2 0.8-0.3 1.5-0.8c5.9-4.2 11.5-11.4 11.5-11.4 0 0 21.1 17.1 20.4 17.6-3.4 2.4-6.9 5.3-10 8-5 4.4-9 8.2-9.6 8.3-8.6 1.1-22.3-2-24.7-7.9-2.3-5.6 7.7-12.2 10.7-13.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m719.4 658.3c-6.4 3.1-22.8 9.5-31.2-1.7q-0.9-1.1-1.4-2.2 0.1-0.1 0.2-0.2 0.8-0.3 1.5-0.8c6-4.2 11.6-11.4 11.6-11.4 0 0 15.2 12.3 19.3 16.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m744.6 648.5c-7 6.7-33.1 14.3-41.4 11-12-4.6-19.7-18.2-12.8-30 6.8-11.3 41-20.6 49.2-16.4 12 6.1 15.4 25.5 5 35.4z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m716.8 632.6c0.1 0 0 0.2-0.1 0.2-1.8 0.6-3.7 1.6-3.7 3.4 0 0-0.1 0.1-0.1 0-0.5-2.1 2.1-3.3 3.9-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m719.2 633.6c1.3 2.7-4.3 5-5.5 2.4-1.1-2.5 4.5-4.8 5.5-2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m707.8 623c0 0 0.1 0 0.1 0 1.2 1.3 3.3 0.8 5 0 0.1 0 0.3 0 0.2 0.1-1.5 1-4.2 1.8-5.3-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m714.3 620.8c-0.9-2.9-6.6-0.9-5.7 1.8 0.8 2.6 6.5 0.6 5.7-1.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m722.9 634.7c-0.1-0.8 0-1.6 0-2.5 0-0.9-0.1-1.7 0.5-2.5 0.3-0.4 1.1-0.5 1.5-0.3 1.1 0.6 1.4 1.8 1.4 2.9 0 1.3-0.3 2.2-1 3.2-0.8 1-2.3 0.3-2.4-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m717.5 615.5c1.2 0.3 2 0.9 2.7 1.9 0.6 1 1.1 2.1 0.6 3.2-0.2 0.5-0.9 0.8-1.4 0.6-0.9-0.3-1.3-0.9-1.9-1.7-0.5-0.7-1-1.3-1.5-2-0.6-1 0.3-2.4 1.5-2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m703.2 638.8c0-2.5-1.4-5.3-2.3-7-0.1-0.2 0.2-0.5 0.4-0.6 0.1-0.1 3.8-1.4 3.8-1.4-0.5-0.4-2.6-2.4-1.9-2.6 5.9-1.9 12.4-4.1 18.7-4.8 0.2 0 0.3 0.3 0.1 0.4-5.6 2-11.5 3.1-17.1 5.1 0.6 0.7 1.7 1.7 1.9 2.4 0 0.3-4 1.3-4.6 1.6 0 0 2.5 3.1 1.8 6.7-0.2 0.9-0.8 1.4-0.8 0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m699.1 636.8c0-1.1 3.4-4.2 4.3-2.6 0.9 1.6 1.4 5.9-0.6 8.3-1.7 2.2-2.1-3.5-2.7-4.1-0.5-0.6-0.9-0.8-1-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m700.1 638.3q-0.2-0.1-0.3-0.3c1.2-0.5 3.1-0.2 4.1 2.1-0.2 0.9-0.6 1.8-1.1 2.4-1.7 2.1-2.1-3.5-2.7-4.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m700.7 646c-0.7 0.1-1.6-0.1-2-0.8-0.5-0.7-0.4-1.8 0.1-2.5 0-0.1 0.1-0.1 0.1 0 0 0.6 0 1.4 0.3 2 0.3 0.6 1 0.8 1.6 1.1 0 0 0.1 0.2-0.1 0.2z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m724.5 657c-3.1-6 2.9-12.4 9.4-13.5 0 0-9.2-15.5 3.6-21.9 0 0-8.1-1.5-11.5-8.9l-4.7 1c-0.2-1.9 3.8-5.7 9.3-3.2 0 0 6.7-2.5 12.7 0.6 6.1 3.1 5.5 9.1 5.5 9.1 0 0 4.9 2.4 6.7 8.8 1.9 6.4-2.6 11.2-2.6 11.2 0 0 2 8.8-3.2 12.7-5.2 3.8-10.3 2.5-10.3 2.5 0 0-1.4 3-6.8 4.1-3.4 0.7-7.2-0.7-8.1-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m738.8 621.5c-1.1 0.3-2.2 0.7-3.2 1.3-1.1 0.5-2 1.2-2.9 1.9-1.7 1.6-2.8 3.6-3.1 5.9-0.3 2.2 0.4 4.5 1.1 6.7 0.5 1 0.9 2.1 1.5 3.1 0.6 1 1.1 2.1 1.7 3.1-0.7-0.9-1.4-1.9-2.1-2.9-0.6-1-1.1-2.1-1.7-3.1-0.8-2.2-1.6-4.6-1.3-7 0.3-2.5 1.6-4.8 3.5-6.2 1.9-1.5 4.2-2.5 6.5-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m752.9 640.2c0.9 2.1 1.4 4.3 1.3 6.6 0 2.3-0.7 4.7-2.3 6.4q-1.2 1.3-2.7 2.1c-1 0.6-2.1 1-3.2 1.3-2.3 0.4-4.7 0-6.6-1.2 2 0.9 4.3 1.1 6.4 0.5 2.1-0.5 4.1-1.6 5.5-3.2 0.7-0.8 1.3-1.7 1.7-2.7q0.5-1.6 0.6-3.2c0.1-2.2-0.1-4.4-0.7-6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m748.8 620.2c-0.1-1.9-0.4-3.6-1.1-5.3-0.7-1.6-1.7-3.1-3-4.1-1.4-1.1-3-1.7-4.8-2-1.7-0.3-3.5-0.3-5.3-0.1 1.7-0.5 3.6-0.7 5.4-0.6 1.9 0.2 3.7 0.8 5.2 2 1.5 1.2 2.5 2.9 3.1 4.6 0.6 1.8 0.8 3.6 0.5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m727.6 616.3c1.4 1.5 3 2.9 4.8 3.8 0.9 0.5 1.8 0.8 2.8 1.1 1 0.2 2 0.2 3.1 0.3-1 0.3-2.1 0.4-3.2 0.3-1.1-0.1-2.1-0.5-3.1-1-1-0.5-1.8-1.1-2.6-1.9-0.7-0.8-1.4-1.6-1.8-2.6z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m721.6 652.4c0 0 10.4 1.8 10.1 6.2-0.2 4.5-13.5 5.8-17 2.4-3.6-3.5-0.4-6.8-0.4-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m727.9 658.9c0.1 0.1 0 0.1-0.1 0.1-2.5-2.4-6-2.6-9.3-2.4 1.5 0.4 2.7 1.3 2.3 3.2 0 0.1-0.2 0.1-0.2 0-0.3-1.3-0.9-2-2.3-2.4-0.9-0.3-2-0.2-2.9-0.3-0.4 0-0.4-0.5-0.1-0.6q0 0 0.1 0c3.7-1.8 10.3-1.4 12.5 2.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m712.5 642.9c0.1 0.1 0 0.4-0.2 0.5-0.2 0.1-0.4 0-0.5-0.2-0.1-0.2 0-0.4 0.2-0.5 0.2-0.1 0.4 0 0.5 0.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m709.2 635.8c0.1 0.2 0 0.4-0.2 0.5-0.2 0.1-0.4 0.1-0.5-0.1-0.1-0.2 0-0.4 0.2-0.5 0.2-0.1 0.4-0.1 0.5 0.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m708 639.5c0.1 0.2 0.1 0.4-0.1 0.5-0.2 0.1-0.4 0-0.5-0.1-0.1-0.2 0-0.4 0.1-0.5 0.2-0.1 0.5-0.1 0.5 0.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m715.1 641.2c0.1 0.2 0 0.4-0.2 0.5-0.1 0.1-0.4 0.1-0.5-0.1-0.1-0.2 0-0.4 0.2-0.5 0.2-0.1 0.4 0 0.5 0.1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m711.5 639c0.1 0.2 0.1 0.4-0.1 0.5-0.2 0.1-0.4 0-0.5-0.2-0.1-0.2 0-0.4 0.1-0.5 0.2-0.1 0.4 0 0.5 0.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m707.4 619.6c0.1 0.2 0 0.4-0.2 0.5-0.2 0.1-0.4 0-0.5-0.2-0.1-0.1 0-0.4 0.2-0.5 0.2-0.1 0.4 0 0.5 0.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m706.9 623.1c0.1 0.2 0 0.4-0.2 0.5-0.2 0.1-0.4 0.1-0.5-0.1-0.1-0.2 0-0.4 0.2-0.5 0.1-0.1 0.4 0 0.5 0.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m704.4 623.6c0 0.2 0 0.4-0.2 0.5-0.2 0.1-0.4 0-0.5-0.1-0.1-0.2 0-0.4 0.2-0.5 0.1-0.1 0.4-0.1 0.5 0.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m704.7 620.6c0.1 0.2 0 0.4-0.2 0.5-0.2 0.1-0.4 0-0.5-0.2-0.1-0.1 0-0.4 0.2-0.5 0.2-0.1 0.4 0 0.5 0.2z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m675.7 669.2c-2.3-3.4-0.9-6.4 1-8.5 1.7-1.8 10.1-8.4 10.5-7.6 0.5 0.7 2.1 6.6 6.2 10.7 4.2 4 16.4 5.1 16.7 6.5 0.4 1.3-9.5 7.8-9.5 7.8-5.2 1.5-20.5-2.5-24.9-8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m707 670.7c-2.8 1.5-5.2 3.5-7.2 5.9 2.7-1.5 5.2-3.5 7.2-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m686.9 654.7c-2.9 1.3-5.4 3.2-7.6 5.4 2.8-1.3 5.4-3.2 7.6-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m686.7 658.2c-3.7 2-7 4.4-10 7.3 3.6-2 7-4.4 10-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m688.8 662.1c-3.6 1.9-7 4.3-10 7.2 3.6-1.9 7-4.4 10-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m692.8 665.4c-3.7 2-7.1 4.4-10.1 7.3 3.7-2 7.1-4.4 10.1-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m696.9 667.9c-3.5 1.8-6.7 4.1-9.6 6.8 3.5-1.8 6.8-4.1 9.6-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m701.8 669.6c-3.1 1.7-5.8 3.9-8.2 6.4 3.1-1.6 5.9-3.8 8.2-6.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m699.4 687.5c-2.1 0.8-4.4 1.1-7 0.6-7.7-1.3-16.6-9.3-19.4-19.7-1.7-6.6-0.7-11.6 1.8-14.8 2.7 14.5 12.6 27.4 24.6 33.9z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m711 692.7c-23.8-3.6-45.3-33.1-36.1-60.7 6.5-19.5 29.3-36.1 54.8-33.4 36.9 3.8 46.6 37.4 38.8 61.3-8.2 25.3-39.4 35.6-57.5 32.8zm40.1-41.4c4.9-18.8-4.8-45.2-31.6-49.3-18.5-2.9-34.5 9.7-38.7 25-5.9 21.8 10.5 45.9 27.8 49.5 13.1 2.7 37.3-5.3 42.5-25.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m708.6 676.5c-17.3-3.6-33.7-27.7-27.8-49.5 4.2-15.3 20.2-27.9 38.7-25 26.8 4.1 36.5 30.5 31.6 49.3-5.2 19.9-29.4 27.9-42.5 25.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m708.6 676.5c-17.3-3.6-33.7-27.7-27.8-49.5 4.2-15.3 20.2-27.9 38.7-25 26.8 4.1 36.5 30.5 31.6 49.3-5.2 19.9-29.4 27.9-42.5 25.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.2
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m748.7 624.3c-16.8-7.2-35-12.7-54.4-16.3 4-2.8 8.5-4.8 13.4-5.8 11.4 2.7 22.3 6 32.8 10 3.6 3.5 6.3 7.6 8.2 12.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m723.1 675.9c-5.3 1.2-10.4 1.4-14.5 0.6-5.1-1.1-10.2-4-14.6-8 10.1 1.8 19.8 4.3 29.1 7.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m751.2 631.7c-19.1-8.5-40.1-14.9-62.7-18.5q0.6-0.7 1.2-1.3c21.9 3.7 42.4 9.9 61.1 18.1q0.2 0.9 0.4 1.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m738.5 668.9c-16.7-6.9-35.1-12-54.8-14.6q-0.3-0.8-0.7-1.5c20.4 2.7 39.5 8 56.7 15.3q-0.6 0.4-1.2 0.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m729.7 673.8q-0.9 0.3-1.9 0.7c-11.7-4.2-24.2-7.5-37.2-9.6q-0.7-0.8-1.3-1.6c14.2 2.3 27.7 5.8 40.4 10.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m747.4 659.6c-20.2-9.2-43-15.8-67.6-18.8q-0.3-2.6-0.2-5.1c25.5 3.2 49.1 10.1 70 19.8q-0.9 2.2-2.2 4.1z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m720.3 682c2.4-5.9 10.4-11.6 19.2-11.9 12.7-0.4 15.7 8.8 12.9 15.9-3 7.6-13.9 11.8-20.1 11.8-8.1 0-15.3-7.6-12-15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m720.3 682c2.4-5.9 10.4-11.6 19.2-11.9 12.7-0.4 15.7 8.8 12.9 15.9-3 7.6-13.9 11.8-20.1 11.8-8.1 0-15.3-7.6-12-15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m725.7 686.5c1.9-4.5 8-8.8 14.7-9.1 9.8-0.3 12.1 6.7 10 12.2-2.4 5.9-10.7 9.1-15.4 9.1-6.3 0-11.9-5.8-9.3-12.2z"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m681.9 708.7c-35.7-0.6-84.9-21.6-96.4-29.3-17.7-11.7-10.8-78.8-10.2-92.4 0.2-5.8 51.8 4.2 51.7 10.3-0.1 5.4-7.2 57-5.2 58.2 1.6 1 37.4 20 61.2 33.9 20.5 12 8.3 19.5-1.1 19.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m574.4 602l0.9-15c-3.8-11.2 4-18.3 4-18.3-1.6-1.7-2.6-3.2-2.6-3.2 5.2-6.2 12.8-13 15.7-15.4 6.4-5.4 20.4-1.9 20.4-1.9-1.1-3-5.7-7.7-11.5-15.2-8.1-10.7 2.1-13.5 11.4-4.9 24.4 22.6 20.9 52.2 16.6 63.2-1.8 4.6-2.3 6.7-2.5 8.7-0.1 0.6-1 9.4-1 9.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m578.3 575.3c-2.2-8.8-15.3-12.5-12.3-18.6 2.5-5 8.5-2.8 8.5-2.8 0 0-5.3-5-1.8-9.6 3.9-5.1 12.8 0.2 12.8 0.2 0 0-6.4-6.9-1.2-11.4 7.1-6 25.3 10.5 33.4 20.2 7.3 8.7 12 21 14.1 26.8 0 0-52.9-2.8-53.5-4.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m608.8 563.6c-3.5-3.8-12.3-12.2-23.3-19-0.2-0.1 0-0.3 0.3-0.2 10.7 3.9 20.3 14 23.1 19.1 0.1 0.1 0 0.2-0.1 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m598.8 571.5c-3.7-3.6-12.7-11-24.4-17.6-0.2-0.1 0-0.3 0.3-0.2 11 3.6 21.3 13.5 24.2 17.7 0 0.1 0 0.1-0.1 0.1z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m628.1 621.8c-0.4 8.3-5.5 31.6-4.9 32.5 0.5 0.9 44.5 26.4 59.5 33.8 15 7.4 20.6 25-12 21.1-32.5-3.9-78.5-22.1-88-29.8-9.5-7.6-14.6-46.3-14.1-59.9 0.6-13.7 5.8-17.5 5.8-17.5l51.4 7.4c0 0 2.8 4.2 2.3 12.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m639 663.1c2.8 1.5 5.5 3 8.3 4.6 2.7 1.6 5.5 3.2 8.1 4.9l4.1 2.6c1.3 0.9 2.6 1.8 3.9 2.7-1.5-0.6-2.9-1.4-4.3-2l-4.3-2.3c-2.8-1.4-5.5-3-8.3-4.6-2.7-1.6-5.4-3.2-8.1-4.9-2.7-1.7-5.4-3.4-8-5.3 2.9 1.3 5.7 2.8 8.6 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m658.7 673.5c0.5 0.1 1.1 0.3 1.6 0.5 0.5 0.2 1.1 0.4 1.5 0.8-1.1-0.1-2.2-0.3-3.3-0.6-1.1-0.3-2.2-0.6-3.2-1.1 1.1-0.1 2.3 0.1 3.4 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m604.2 689.8c5.5 2.3 11.1 4.5 16.8 6.4 2.8 1.1 5.6 2 8.5 2.9l8.5 2.7c2.9 0.9 5.8 1.7 8.7 2.5 2.8 0.8 5.8 1.5 8.7 2.3-6-0.9-11.9-2.1-17.7-3.7-5.8-1.5-11.5-3.3-17.2-5.3-5.7-2-11.3-4.2-16.8-6.7q-4.1-1.9-8.1-3.9c-2.7-1.4-5.3-2.8-7.9-4.3q8.2 3.7 16.5 7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m648.2 705.8c1 0.6 2 1.3 2.8 2.2-1.1-0.4-2.2-0.9-3.2-1.6-1-0.6-2-1.3-2.8-2.1 1.2 0.3 2.2 0.9 3.2 1.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m621.4 617.7q-4.9-0.4-9.8-1.1-8.5-1.3-17-2.7c-5.8-0.9-11.5-1.7-17.2-2.9-0.2 0-0.2-0.2 0-0.2 3.3 0.4 6.6 0.8 9.8 1.3q8.5 1.2 17.1 2.4c5.7 0.9 11.5 1.8 17.1 2.9 0.3 0.1 0.3 0.4 0 0.3z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404_Error.b9ab8e655f51bbcd8659ae1f05aa7dba.svg";
export { ForwardRef as ReactComponent };